import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useRef, useState } from 'react';
import { Flex, useColorMode } from '@chakra-ui/react';
import { theme } from '../../../../modules';
import { MediaMenu } from '../MediaMenu';
import { genIconComponent } from '../../index';
export const Medias = memo(function Medias({ mediaData }) {
    const { colorMode } = useColorMode();
    const mediaRef = useRef(null);
    const [collapseCount, setCollapseCount] = useState(0);
    const [opacity, setOpacity] = useState(0);
    useEffect(() => {
        const handle = () => {
            const ele = mediaRef.current;
            const parent = ele?.parentElement?.parentElement;
            if (!parent)
                return;
            const offset = parent.querySelector('.locale-switch-container');
            const switchable = offset?.className.includes('locale-switchable');
            const itemW = window.innerWidth < 768 ? 36 : 40;
            const count = Math.floor((parent.offsetWidth -
                (window.innerWidth < 768 && switchable ? 0 : offset?.offsetWidth || 0) -
                41) /
                itemW);
            const iconCount = mediaData.length;
            setCollapseCount(iconCount > count ? iconCount - count + 1 : 0);
        };
        window.addEventListener('resize', handle);
        handle();
        setOpacity(1);
        return () => {
            window.removeEventListener('resize', handle);
        };
    }, [mediaData.length]);
    const collapseItem = {
        href: '/',
        icon: 'https://cms-static.bnbchain.org/dcms/static/290c8ba1-987a-4cb7-9b81-8f2517801148.svg',
        'data-analytics-id': '',
        target: '_blank',
        children: mediaData.slice(-collapseCount).map((item) => ({
            href: item.href,
            icon: item.icon,
            'data-analytics-id': item['data-analytics-id'] || '',
            name: item.name || '',
            target: item.target,
        })),
    };
    return (_jsxs(Flex, { opacity: opacity, ref: mediaRef, gap: { base: theme.sizes['4'], md: theme.sizes['5'] }, children: [mediaData.slice(0, mediaData.length - collapseCount).map((item, index) => item.children?.length ? (_jsx(MediaMenu, { menu: item }, index)) : (_jsx(Flex, { as: "a", "data-analytics-id": item['data-analytics-id'], href: item.href, target: item.target || '_blank', alignItems: "center", h: theme.sizes['5'], w: theme.sizes['5'], sx: {
                    '.svg-image': {
                        WebkitMaskImage: `url(${item.icon})`,
                        WebkitMaskSize: 'contain',
                        flexShrink: 0,
                        bgColor: theme.colors[colorMode].text.tertiary,
                        '&:hover': {
                            bgColor: theme.colors[colorMode].text.secondary,
                        },
                    },
                    '.svg-icon': {
                        color: theme.colors[colorMode].text.tertiary,
                        '&:hover': {
                            color: theme.colors[colorMode].text.secondary,
                        },
                    },
                }, children: genIconComponent(item.icon) }, index))), collapseCount > 0 && _jsx(MediaMenu, { menu: collapseItem })] }));
});
